import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';
import styled from 'styled-components';

export function UnstyledFontAwesome(props) {
  const componentProps = omit(props, ['theme', 'modifiers']);
  return <FontAwesome {...componentProps} />;
}

/* istanbul ignore next */
const styles = props => `
  color: ${props.theme.colors.base.chrome500};
  padding-left: ${px2rem(6)};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome500: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'RecipientIcon',
  styled(UnstyledFontAwesome),
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NoteCreator/RecipientCount/RecipientIcon.js